import { IPerson } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';

const getPersonsInCompany = async (companyId: number) => {
  const response = await fetcher(`persons/company/${companyId}`, {
    method: 'GET',
  });

  if (!response.ok) throw new Error('Failed to fetch persons in company');

  return (await response.json()) as { persons: IPerson[] };
};

export const personsInCompanyKeys = {
  FETCH_PERSONS_IN_COMPANY: 'FETCH_PERSONS_IN_COMPANY',
};

const usePersonsInCompany = (companyId: number) => {
  return useQuery({
    queryKey: [personsInCompanyKeys.FETCH_PERSONS_IN_COMPANY, companyId],
    queryFn: () => getPersonsInCompany(companyId),
  });
};

export { usePersonsInCompany };
